"use client";

import * as React from "react";
import { Card, type CardProps } from "../card";

export interface ExploreCardFrameProps {
  children: React.ReactNode;
  tone?: "default" | "muted";
  padding?: NonNullable<CardProps["padding"]>;
  shadow?: NonNullable<CardProps["shadow"]>;
  /** RGB triplet e.g. "236,64,122" — applies a 1px colored border to the whole card */
  borderRgb?: string;
  fullHeight?: boolean;
}

export function ExploreCardFrame({
  children,
  tone = "default",
  padding = "xs",
  shadow = "subtle",
  borderRgb,
  fullHeight = false,
}: ExploreCardFrameProps) {
  const borderColor = borderRgb ? `rgba(${borderRgb},0.28)` : undefined;
  return (
    <Card
      size="full"
      variant="default"
      tone={tone}
      padding={padding}
      shadow={shadow}
      entranceAnimation
      borderColor={borderColor}
      fullHeight={fullHeight}
    >
      {children}
    </Card>
  );
}
